/**
 * ectropion.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import EctropionVue from './views/ectropion/ectropion.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/ectropion.js'

async function goApp() {
    const app = createApp(EctropionVue)
    registerPlugins(app, 'ectropion')
    await store.dbinit()
    app.mount('#app')
}

goApp()
